<!-- <div class="banner shadow" [cckBgImage]="'PublishingImages/banner/login/banner.png' | prependBasePath"></div> -->
<img class="img-fluid img-cover shadow" [src]="'PublishingImages/banner/login/banner.png' | prependBasePath" width="100%" height="514" />
